// extracted by mini-css-extract-plugin
export default {"container":"ModelModal_container__CHwco","closeIcon":"ModelModal_closeIcon__bkx4o"};